(function () {
  var MIN_JARS = 6;
  var SWEET_TABLE_CATEGORY = 'slodki-stol';

  document.querySelectorAll('.tasting').forEach(initTasting);

  function initScrollAnimation(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    if (!('IntersectionObserver' in window)) return;

    root.classList.add('tasting--animate');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          entry.target.classList.toggle('is-visible', entry.isIntersecting);
        });
      },
      { threshold: 0.12 }
    );

    observer.observe(root);
  }

  // Keeps the info-icon tooltip inside the viewport, same fix as the
  // cake configurators' tooltips (see custom-cake-configurator.js): even
  // hidden (opacity: 0), a tooltip occupies layout space, so an unshifted
  // one near the edge inflates the page's real scrollable width.
  function wireTooltipReposition(trigger, tooltip, events) {
    if (!tooltip) return;
    function reposition() {
      tooltip.style.marginLeft = '';
      var margin = 8;
      var tooltipRect = tooltip.getBoundingClientRect();
      var viewportWidth = document.documentElement.clientWidth;
      var shift = 0;
      if (tooltipRect.left < margin) {
        shift = margin - tooltipRect.left;
      } else if (tooltipRect.right > viewportWidth - margin) {
        shift = viewportWidth - margin - tooltipRect.right;
      }
      if (shift !== 0) {
        tooltip.style.marginLeft = shift + 'px';
      }
    }
    reposition();
    events.forEach(function (eventName) {
      trigger.addEventListener(eventName, reposition);
    });
    if (window.ResizeObserver) {
      new ResizeObserver(reposition).observe(tooltip);
    }
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(reposition);
    }
    window.addEventListener('resize', reposition);
  }

  function initTasting(root) {
    initScrollAnimation(root);

    root.querySelectorAll('.tasting__info-icon').forEach(function (icon) {
      wireTooltipReposition(icon, icon.querySelector('.tasting__tooltip'), ['mouseenter', 'focus']);
    });

    var form = root.querySelector('.tasting__form form');
    var jarsWrap = root.querySelectorAll('[data-tasting-jars]');
    var summaryEl = root.querySelector('[data-jars-summary]');
    var hintEl = root.querySelector('[data-jars-hint]');
    var jarsLabelEl = root.querySelector('[data-jars-label]');
    var priceEl = root.querySelector('[data-tasting-price]');
    var errorWrapper = root.querySelector('.tasting__error-message-wrapper');
    var errorMessage = root.querySelector('.tasting__error-message');
    var submitButton = root.querySelector('[data-tasting-submit]');
    var categoryRadios = root.querySelectorAll('[data-category-radio]');
    var gallery = root.querySelector('[data-tasting-gallery]');
    var categoryPhotos = root.querySelectorAll('[data-tasting-photo]');
    var sweetTableCheckbox = root.querySelector('[data-sweet-table-checkbox]');

    var config = root.querySelector('[data-tasting-config]');
    var jarVariantMap = {};
    var sweetTablePrice = 130;
    var sweetTableVariantName = '';
    if (config) {
      try {
        jarVariantMap = JSON.parse(config.dataset.jarVariants || '{}');
      } catch (e) {
        jarVariantMap = {};
      }
      sweetTablePrice = parseInt(config.dataset.sweetTablePrice, 10) || 130;
      sweetTableVariantName = config.dataset.sweetTableVariant || '';
    }

    var currentCategory = SWEET_TABLE_CATEGORY;

    function formatMoney(amount) {
      return amount.toFixed(2).replace('.00', '').replace('.', ',') + ' zł';
    }

    // Tiramisu and the sweet table each have one photo; every other category
    // keeps the mosaic. The gallery carries the class so the CSS can hide the
    // mosaic and the phone slider, which media queries control.
    function showGallery(key) {
      var matched = false;
      categoryPhotos.forEach(function (el) {
        var isMatch = el.dataset.tastingPhoto === key;
        el.classList.toggle('tasting__category-photo--active', isMatch);
        if (isMatch) matched = true;
      });
      if (gallery) gallery.classList.toggle('tasting__gallery--single', matched);
    }

    function showCategory(key) {
      currentCategory = key;
      jarsWrap.forEach(function (el) {
        el.hidden = el.dataset.tastingJars !== key;
      });
      showGallery(key);
      var isSweetTable = key === SWEET_TABLE_CATEGORY;
      if (summaryEl) summaryEl.hidden = isSweetTable;
      if (hintEl) hintEl.hidden = isSweetTable;
      if (jarsLabelEl) jarsLabelEl.hidden = isSweetTable;
      updateTotals();
    }

    categoryRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        if (radio.checked) showCategory(radio.value);
      });
    });

    var initialCategory = root.querySelector('[data-category-radio]:checked');
    if (initialCategory) showCategory(initialCategory.value);

    function getAllJarButtons() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-jar]'));
    }

    function getQty(jarEl) {
      return parseInt(jarEl.dataset.qty || '0', 10) || 0;
    }

    function setQty(jarEl, qty) {
      var next = Math.max(0, qty);
      jarEl.dataset.qty = String(next);
      var qtyEl = jarEl.querySelector('[data-jar-qty]');
      if (qtyEl) qtyEl.textContent = next;
      updateTotals();
    }

    function getJarPrice(jarEl) {
      return parseInt(jarEl.dataset.jarPrice || '0', 10) || 0;
    }

    function updateTotals() {
      var jars = getAllJarButtons();
      var totalJars = 0;
      var totalPrice = 0;
      var parts = [];
      jars.forEach(function (jarEl) {
        var qty = getQty(jarEl);
        if (qty > 0) {
          totalJars += qty;
          totalPrice += qty * getJarPrice(jarEl);
          parts.push(jarEl.dataset.jarName + ' (' + qty + ')');
        }
      });

      if (summaryEl) {
        summaryEl.textContent = parts.length ? parts.join(' / ') : 'Nie wybrano jeszcze żadnych smaków.';
      }
      if (hintEl) {
        var valid = totalJars >= MIN_JARS;
        hintEl.dataset.jarsValid = valid ? 'true' : 'false';
        hintEl.textContent = 'Wybrano ' + totalJars + ' / minimalna liczba zamówienia to ' + MIN_JARS + ' słoiczków.';
      }

      if (sweetTableCheckbox && sweetTableCheckbox.checked) totalPrice += sweetTablePrice;
      if (priceEl) priceEl.textContent = formatMoney(totalPrice);

      return totalJars;
    }

    getAllJarButtons().forEach(function (jarEl) {
      var decrease = jarEl.querySelector('[data-jar-decrease]');
      var increase = jarEl.querySelector('[data-jar-increase]');
      if (decrease) {
        decrease.addEventListener('click', function () {
          setQty(jarEl, getQty(jarEl) - 1);
        });
      }
      if (increase) {
        increase.addEventListener('click', function () {
          setQty(jarEl, getQty(jarEl) + 1);
        });
      }
    });

    if (sweetTableCheckbox) {
      sweetTableCheckbox.addEventListener('change', updateTotals);
    }

    updateTotals();

    if (!form) return;

    function showError(message) {
      if (!errorWrapper || !errorMessage) return;
      errorMessage.textContent = message;
      errorWrapper.hidden = false;
      errorWrapper.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      if (errorWrapper) errorWrapper.hidden = true;

      var terminInput = form.querySelector('input[name="id"]:checked');
      if (!terminInput) {
        showError('Wybierz dostępny termin degustacji.');
        return;
      }

      var weddingDateInput = form.querySelector('input[type="date"][required]');
      if (weddingDateInput && !weddingDateInput.value) {
        showError('Podaj datę przyjęcia.');
        weddingDateInput.focus();
        return;
      }

      var isSweetTable = currentCategory === SWEET_TABLE_CATEGORY;

      if (isSweetTable) {
        if (!sweetTableCheckbox || !sweetTableCheckbox.checked) {
          showError('Zaznacz degustację słodkiego stołu, aby kontynuować.');
          return;
        }
      } else {
        var totalJars = updateTotals();
        if (totalJars < MIN_JARS) {
          showError('Minimalna liczba zamówienia to ' + MIN_JARS + ' słoiczków — wybierz więcej smaków.');
          return;
        }
      }

      var properties = {};
      form.querySelectorAll('[name^="properties["]').forEach(function (field) {
        var match = field.name.match(/properties\[(.+)\]/);
        if (!match) return;
        var key = match[1];
        if (field.type === 'checkbox' || field.type === 'radio') {
          if (field.checked) properties[key] = field.value;
          return;
        }
        if (field.value) properties[key] = field.value;
      });

      var items = [{ id: Number(terminInput.value), quantity: 1, properties: properties }];

      if (isSweetTable) {
        var sweetVariantId = jarVariantMap[sweetTableVariantName];
        if (sweetVariantId) items.push({ id: Number(sweetVariantId), quantity: 1 });
      } else {
        getAllJarButtons().forEach(function (jarEl) {
          var qty = getQty(jarEl);
          if (qty <= 0) return;
          var flavorName = jarEl.dataset.jarName;
          var variantId = jarVariantMap[flavorName];
          if (!variantId) return;
          items.push({ id: Number(variantId), quantity: qty });
        });
      }

      if (submitButton) submitButton.disabled = true;

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items }),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) {
            throw new Error(result.data.description || result.data.message || 'Nie udało się dodać rezerwacji do koszyka.');
          }
          window.location.href = window.Shopify.routes.root + 'cart';
        })
        .catch(function (error) {
          showError(error.message);
        })
        .finally(function () {
          if (submitButton) submitButton.disabled = false;
        });
    });
  }
})();
